// Las piezas de Agencias de la app (shared.js, la ficha del Explorador…)
// traducen con window.i18n. El backoffice no lo tiene: aquí se le da uno con
// los textos en español de la app. Va en su propio módulo para que exista
// antes de que se evalúen esas piezas (los import se evalúan en orden).
import es from '../../../renderer/i18n/locales/es.json';

if (!globalThis.i18n) {
  globalThis.i18n = {
    t: (key) => (Object.prototype.hasOwnProperty.call(es, key) ? es[key] : key),
    getCurrentLanguage: () => 'es'
  };
}

export const APP_TEXTS_ES = es;
